import React, { useState } from "react";
import { Link } from "react-router-dom";

import "./HomeNavbar.css";

const navItems = [
	{ to: "/", name: "Home" },
	{ to: "/members", name: "Members" },
	{ to: "/projects", name: "Projects" },
	{ to: "/publications", name: "Publications" },
];

const HomeNavbar = () => {
	const [isNavExpanded, setIsNavExpanded] = useState(false);

	return (
		<div className="navbar-container">
			<div className="left-section">
				<Link to="/">
					<div className="web-logo">Seo Lab</div>
				</Link>
			</div>
			<div className="middle-section">
				<ul className={`nav-list ${isNavExpanded ? "active" : ""}`}>
					{navItems.map((item) => (
						<li className="nav-item">
							<Link to={item.to}>{item.name}</Link>
						</li>
					))}
				</ul>
				<div
					className="expand-menu"
					onClick={() => setIsNavExpanded(!isNavExpanded)}
				>
					<span className="bar"></span>
					<span className="bar"></span>
					<span className="bar"></span>
				</div>
			</div>
			<div className="right-section">
				<Link to="/contact">
					<button className="contact-button">Contact</button>
				</Link>
			</div>
		</div>
	);
};

export default HomeNavbar;
